module.exports = __webpack_public_path__ + "img/05.fe87575d.jpg";